<!-- eslint-disable linebreak-style -->
<template>
  <f7-page class="main-OrderDetail">
    <TheNavbar
      v-if="navbarBtn"
      class="container-navbar"
      :nav-title="`${actualOrder.Serie} / ${actualOrder.Numero}`"
      back-btn-enable
      add-btn-enable
      :back-callback="callBackBtn"
      @add-btn="PressBtnAdd"
    >
      <template #btn-right>
        <f7-link @click="openOptions = true">
          <img
            src="@/static/icons/ic_options_tierra.svg"
            height="38px"
            width="38px"
          >
        </f7-link>
        <f7-link @click="saveSaleOrder">
          <img
            src="@/static/icons/ic_save.svg"
            height="38px"
            width="38px"
          >
        </f7-link>
      </template>
    </TheNavbar>

    <div class="container-header min-h-min">
      <div class="display-flex w-100">
        <div class="w-20 text-color-metal-tint">
          {{ `${$t('common.customer')}:` }}
        </div>
        <div class="text-color-metal-tint font-medium">
          {{ dataClient?.Nombre ?? '' }}
        </div>
      </div>
      <div class="display-flex w-100 mt-1">
        <div class="w-20 text-color-metal-tint">
          {{ `${$t('common.destination')}:` }}
        </div>
        <div class="text-color-metal-tint font-medium">
          {{ actualOrder?.DireccionEnvio?.Nombre ?? '' }}
        </div>
      </div>
      <div class="display-flex w-100 mt-1">
        <div class="w-20 text-color-metal-tint">
          {{ `${$t('common.referenceShort')}:` }}
        </div>
        <div class="text-color-metal-tint font-medium">
          {{ actualOrder.Referencia ?? $t('commercialization.common.noReference') }}
        </div>
      </div>
    </div>
    <div
      class="container-toolbar"
    >
      <UCToolbar
        :key="toolbarKey"
        class="content-toolbar"
        :is-bottom="false"
        :data="dataTabbar"
        tabbar-link="1"
      >
        <template #tabs>
          <f7-tabs>
            <f7-tab
              id="tab-1"
              tab-active
            >
              <!-- <UCEmptyList
                v-if="actualOrder.lineasPedidoVenta.length === 0"
                :title="$t('commercialization.common.noLine')"
                :subtitle="$t('commercialization.common.pressButtonToAddNewLine')"
                icon="./static/icons/ic_add_new.svg"
                @click="PressBtnAdd"
              /> -->
              <div
                v-if="actualOrder.lineasPedidoVenta.length === 0"
                class="display-flex flex-direction-column align-items-center text-align-center w-100 pt-10 mt-4 "
              >
                <img
                  class="mt-12"
                  src="@/static/icons/ic_add_new.svg"
                  height="55px"
                  width="55px"
                  @click="PressBtnAdd"
                >
                <span class="size-18 font-medium margin-top">{{ $t('commercialization.salesOrders.labels.noOrders') }}</span>
                <span class="size-14 text-color-metal margin-top w-50">{{ $t('commercialization.salesOrders.labels.noOrdersText') }}</span>
              </div>
              <div
                v-else
                class="content-toolbar__acordeon"
              >
                <div
                  v-for="(option, j) in elementFilter"
                  :key="j"
                >
                  <UCAcordeon
                    :items="[option]"
                    :show-badge="true"
                    :opened-index="0"
                    primary="var(--his-tierra-shade)"
                    secondary="var(--his-tomate)"
                    font-color="var(--his-metal-tint)"
                    :after-title="false"
                  >
                    <template #titleOption>
                      {{ option.Estado }}
                    </template>
                    <template #subOption="{ item }">
                      <f7-list media-list>
                        <f7-list-item
                          class="content-toolbar__acordeon--item"
                          @click="GetOrderLineSelected(item)"
                        >
                          <template #title>
                            <div class="truncate-x2">
                              <span
                                v-if="item.TipoLinea === 1"
                              >
                                {{ item.TextoLinea }}
                              </span>
                              <span
                                v-else
                              >
                                <span
                                  v-if="item.Articulo.Composicion === null"
                                >
                                  {{ item.Articulo.Nombre }}
                                </span>
                                <span v-else>
                                  <span
                                    v-for="(comp, i) in item.Articulo.Composicion.Componentes"
                                    :key="i"
                                    class="text"
                                  >
                                    <span v-if="comp.Orden === 2">{{ comp.Nombre }}</span>
                                  </span>
                                </span>
                                <span>
                                  {{ ` + ${item.InfoEnvase.Nombre} + ${item.InfoPale.Nombre}` }}
                                </span>
                              </span>
                            </div>
                          </template>
                          <template #after>
                            <div class="ml-6">
                              <img
                                src="@/static/icons/ic_shape_right.svg"
                              >
                            </div>
                          </template>

                          <template
                            v-if="item.TipoLinea !== 1"
                            #subtitle
                          >
                            <div

                              class="display-flex align-items-center justify-content-space-between mt-3"
                            >
                              <div class="display-flex align-items-center text-color-metal-shade">
                                <img
                                  class="margin-right-half"
                                  src="@/static/icons/ic_palet_grey.svg"
                                >

                                <div>
                                  {{ `${item.CantidadPales} ${$t('commercialization.common.palletsLabel')}` }}
                                </div>
                              </div>
                              <div class="display-flex align-items-center text-color-metal-shade">
                                <img
                                  class="margin-right-half"
                                  src="@/static/icons/ic_box_grey.svg"
                                >
                                <div>
                                  {{ `${item.EnvasesPorPalet} ${$t('commercialization.common.packagesPerPalletShort')}` }}
                                </div>
                              </div>
                              <div class="text-color-tomate font-medium">
                                {{ `${item.Precio} ${divisaSelected?.Simbolo ?? ''}/${item.PrecioPor?.Codigo}` }}
                              </div>
                              <div class="content-toolbar__acordeon--item__subtitle-Percent">
                                <div
                                  v-if="item.Id !== 0"
                                >
                                  <div
                                    v-if="cargandoPorentajes"
                                    class="content-toolbar__acordeon--item__subtitle-Percent--percent content-toolbar__acordeon--item__subtitle-Percent--pending"
                                  >
                                    {{ $t('common.loading') }}
                                  </div>
                                  <div
                                    v-else
                                    class="content-toolbar__acordeon--item__subtitle-Percent--percent"
                                    :class="{
                                      'content-toolbar__acordeon--item__subtitle-Percent--pending': gerPercentage(item) === 0,
                                      'content-toolbar__acordeon--item__subtitle-Percent--in-process': gerPercentage(item) > 0 && gerPercentage(item) < 100,
                                      'content-toolbar__acordeon--item__subtitle-Percent--finished': gerPercentage(item) === 100,
                                    }"
                                  >
                                    {{ `${gerPercentage(item)}%` }}
                                  </div>
                                </div>
                                <div
                                  v-else
                                  class="content-toolbar__acordeon--item__subtitle-Percent--percent content-toolbar__acordeon--item__subtitle-Percent--pending"
                                >
                                  {{ `${'0%'}` }}
                                </div>
                              </div>
                            </div>
                          </template>
                        </f7-list-item>
                      </f7-list>
                    </template>
                  </UCAcordeon>
                </div>
              </div>
            </f7-tab>
            <f7-tab
              id="tab-2"
            >
              <div class="content-toolbar__other pt-2">
                <div class="margin-left-half margin-bottom-half text-color-metal-dark">
                  {{ $t('common.observations') }}
                </div>
                <f7-text-editor
                  :resizable="true"
                  name="textarea"
                  :placeholder="$t('common.text')"
                  mode="popover"
                  :buttons="['bold', 'italic', 'underline', 'strikeThrough']"
                  :value="observations"
                  @texteditor:change="(value) => observations = value"
                />

                <f7-list
                  accordion-list
                  inset
                  class="container-complementary-data"
                >
                  <f7-list-item
                    accordion-item
                    :title="$t('common.supplementaryData')"
                  >
                    <f7-accordion-content>
                      <div>
                        <UCDatosComplementarios
                          :default-datos-complementarios="[]"
                          :activo="true"
                          :entidad-seleccionada="{ Id: 0 }"
                          :edition="true"
                          tipo-entidad-seleccionada="LineaPedidoVenta"
                        />
                      </div>
                    </f7-accordion-content>
                  </f7-list-item>
                </f7-list>
              </div>
            </f7-tab>
          </f7-tabs>
        </template>
      </UCToolbar>
    </div>
    <!-- <UCPreload :show="showPreload" /> -->
    <!-- ACTION DELETE -->
    <f7-actions
      :opened="DeleteOrder"
      @actions:closed="DeleteOrder = false"
    >
      <f7-actions-group class="order-detail-action-delete-order">
        <f7-actions-label>
          <div class="size-18 text-align-center text-color-metal-shade mt-3 mb-4">
            <span>{{ $t('commercialization.salesOrders.orderDetail.youGoing') }}</span>
            <span class="text-color-tomate font-semibold">{{ $t('common.delete').toLowerCase() }}</span>
            <span>{{ $t('commercialization.salesOrders.orderDetail.orderAndData') }}</span>
            <span class="font-semibold">{{ $t('commercialization.salesOrders.orderDetail.sure') }}</span>
          </div>
        </f7-actions-label>
        <f7-actions-button
          class="order-detail-action-delete-order__btn-delete"
          @click="PressDescartarPedido"
        >
          {{ $t('commercialization.common.yesDiscardOrder').toUpperCase() }}
        </f7-actions-button>
        <f7-actions-button
          class="order-detail-action-delete-order__btn-cancel mt-3"
          @click="DeleteOrder = false"
        >
          {{ $t('common.cancel').toUpperCase() }}
        </f7-actions-button>
      </f7-actions-group>
    </f7-actions>
    <f7-actions
      :opened="LineItemOptions"
      @actions:closed="LineItemOptions = false"
    >
      <f7-actions-group
        v-if="orderLineSelected"
        class="order-detail-action-item-options"
      >
        <div class="order-detail-action-item-options__title display-flex align-items-center justify-content-space-between">
          <div class="display-flex align-items-center">
            <img
              class="margin-right"
              src="@/static/icons/ic_clock.svg"
              height="36"
              width="36"
            >
            <span class="text-color-metal-dark size-16 font-medium"> {{ deliveryDate }}</span>
          </div>
          <div
            class="display-flex align-items-center"
            @click="CloseLineItemOptions()"
          >
            <img
              src="@/static/icons/ic_close_grey2.svg"
              height="36"
              width="36"
            >
          </div>
        </div>

        <div class="size-16 font-semibold text-color-berenjena truncate-x2 mt-6 mb-4">
          <span
            v-if="orderLineSelected.TipoLinea === 1"
          >
            {{ orderLineSelected.TextoLinea }}
          </span>
          <span v-else>
            <span
              v-if="orderLineSelected.Articulo.Composicion === null"
            >
              {{ orderLineSelected.Articulo.Nombre }}
            </span>
            <span v-else>
              <span
                v-for="(comp, i) in orderLineSelected.Articulo.Composicion.Componentes"
                :key="i"
              >
                <span v-if="comp.Orden === 2">{{ comp.Nombre }}</span>
              </span>
            </span>
            <span>
              {{ ` + ${orderLineSelected.InfoEnvase.Nombre} + ${orderLineSelected.InfoPale.Nombre}` }}
            </span>
          </span>
        </div>

        <div
          v-if="orderLineSelected.TipoLinea !== 1"
          class="display-flex"
        >
          <div class="display-flex align-items-center text-color-metal-shade mr-4">
            <img
              class="margin-right-half"
              src="@/static/icons/ic_palet_grey.svg"
            >
            <div>{{ `${orderLineSelected.CantidadPales} ${$t('commercialization.common.palletsLabel')}` }}</div>
          </div>
          <div class="display-flex align-items-center text-color-metal-shade mr-4">
            <img
              class="margin-right-half"
              src="@/static/icons/ic_box_grey.svg"
            >
            <div>{{ `${orderLineSelected.EnvasesPorPalet} ${$t('commercialization.common.packagesPerPalletShort')}` }}</div>
          </div>
          <div class="display-flex align-items-center text-color-tomate font-medium mr-4">
            {{ `${orderLineSelected.Precio} ${divisaSelected?.Simbolo ?? ''}/${orderLineSelected.PrecioPor?.Codigo}` }}
          </div>
        </div>

        <div class="display-flex mt-7">
          <f7-actions-button
            class="order-detail-action-item-options__btn-duplicate mr-3"
            @click="duplicateLine(orderLineSelected)"
          >
            <img
              class="margin-right"
              src="@/static/img/ic_duplicate_white.svg"
            >
            <span v-if="orderLineSelected.PaleMixto !== 0 && orderLineSelected.TipoLinea === 0">
              {{ $t('common.repeatPallet') }}
            </span>
            <span v-else>
              {{ $t('common.repeatLine') }}
            </span>
          </f7-actions-button>
          <f7-actions-button
            class="order-detail-action-item-options__btn-edit"
            @click="editLine(orderLineSelected)"
          >
            <img
              class="margin-right"
              src="@/static/img/ic_edit_without_borders.svg"
            >
            {{ $t('common.edit') }}
          </f7-actions-button>
        </div>
        <f7-actions-button
          class="order-detail-action-item-options__btn-delete mt-3 mb-3"
          @click="deleteLine(orderLineSelected)"
        >
          <img
            class="margin-right"
            src="@/static/icons/ic_delete2.svg"
            width="16"
            height="16"
          >
          {{ $t('commercialization.common.deleteLine').toUpperCase() }}
        </f7-actions-button>
      </f7-actions-group>
    </f7-actions>
    <f7-actions
      :grid="true"
      :opened="selectCompleteOrMixt"
      @actions:closed="selectCompleteOrMixt = false"
    >
      <f7-actions-group class="order-detail-action-options-line">
        <f7-actions-label class="size-18 text-align-center text-color-metal-shade mt-3">
          <div>
            <span>{{ $t('commercialization.salesOrders.orderDetail.whatTypeOfPale') }}</span>
            <span class="font-semibold">{{ $t('commercialization.salesOrders.orderDetail.orderLine') }}</span>
          </div>
        </f7-actions-label>
        <f7-actions-button
          class="mb-5"
          @click="PressCompleto"
        >
          <template #media>
            <img
              class="mb-3"
              src="@/static/icons/ic_palet_simple_grey.svg"
            >
          </template>
          <span class="text-color-metal-dark size-18">{{ $t('common.numberCompleted') }}</span>
        </f7-actions-button>
        <f7-actions-button
          v-if="unidadesLogisticasEnProducion"
          class="mb-5"
          @click="PressMixto"
        >
          <template #media>
            <img
              class="mb-3"
              src="@/static/icons/ic_palet_mixto_grey.svg"
            >
          </template>
          <span class="text-color-metal-dark size-18">{{ $t('common.mixed') }}</span>
        </f7-actions-button>
        <f7-actions-button
          class="mb-5"
          @click="PressText"
        >
          <template #media>
            <img
              class="mb-3"
              src="@/static/icons/ic_palet_texto_grey.svg"
            >
          </template>
          <span class="text-color-metal-dark size-18">{{ $t('common.text') }}</span>
        </f7-actions-button>
      </f7-actions-group>
    </f7-actions>
    <f7-actions
      :opened="openOptions"
      :grid="true"
      @actions:closed="openOptions = false"
    >
      <f7-actions-group class="order-detail-action-options-order">
        <f7-actions-label>
          {{ $t('commercialization.common.orderOptions').toUpperCase() }}
        </f7-actions-label>
        <f7-actions-button
          v-if="actualOrder.Id !== 0 ? true : false"
          class="mb-5 mt-5"
          @click="DeleteOrder = true"
        >
          <template #media>
            <img
              class="mb-3"
              src="@/static/icons/ic_delete.svg"
              width="52"
              height="52"
            >
          </template>
          <span class="text-color-tomate size-18 font-medium">{{ $t('common.delete') }}</span>
        </f7-actions-button>
        <f7-actions-button
          v-if="actualOrder.Id !== 0 ? true : false"
          class="mb-5 mt-5"
          @click="duplicateOrder()"
        >
          <template #media>
            <img
              class="mb-3"
              src="@/static/icons/ic_duplicy.svg"
              width="52"
              height="52"
            >
          </template>
          <span class="text-color-berenjena size-18 font-medium">{{ $t('common.duplicate') }}</span>
        </f7-actions-button>
        <f7-actions-button
          class="mb-5 mt-5"
          @click="editOrder()"
        >
          <template #media>
            <img
              class="mb-3"
              src="@/static/icons/ic_edit_black.svg"
              width="52"
              height="52"
            >
          </template>
          <span class="text-color-berenjena size-18 font-medium">{{ $t('common.edit') }}</span>
        </f7-actions-button>
      </f7-actions-group>
    </f7-actions>

    <UCConfirmation
      ref="UCConfirmation"
      class="container-confirmation-frm-order-detail"
    />
  </f7-page>
</template>

<script>
import { mapActions, mapState, mapWritableState } from 'pinia';
import { useAppOrdersStore } from '@/js/stores/appOrders';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useParamRef } from '@erpagroapp/params';
import TheNavbar from '@/components/TheNavbar.vue';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import UCToolbar from '@/components/common/UCToolbar.vue';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import { ConfirmDialogGH, HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import APIErp, { callExecuteSPERP } from '@/js/services/APIErp';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import UCDatosComplementarios from '@/components/common/UCDatosComplementarios.vue';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';

export default {
  name: 'OrderDetail',

  components: {
    TheNavbar,
    UCToolbar,
    UCAcordeon,
    UCConfirmation,
    UCDatosComplementarios,
  },

  props: {
    filtros: {
      type: Object,
      default: null,
    },
    nuevoPedido: {
      type: Boolean,
      default: true,
    },
    // TODO: Si esta a true mostramos nav con btn eliminar y copiar el mandamos un booleano para mostra la nav con los btn o solo la nav con el salir
    navbarBtn: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      elementFilter: [],
      LineItemOptions: false,
      selectCompleteOrMixt: false,
      DeleteOrder: false,
      orderLineSelected: null,
      deliveryDate: null,
      observations: '',
      ordersData: null,
      divisaSelected: null,
      cargandoPorentajes: true,
      dataTabbar: [
        {
          title: this.$t('common.lines').toUpperCase(),
          badge: '',
          href: '',
          tablink: '1',
        },
        {
          title: this.$t('common.otherPl').toUpperCase(),
          badge: '',
          href: '',
          tablink: '2',
        },
      ],
      unidadesLogisticasEnProducion: useParamRef('UnidadesLogisticasEnProducion'),
      filtrarPedidosVentaVendedorAPP: useParamRef('FiltrarPedidosVentaVendedorAPP'),
      openOptions: false,
    };
  },

  computed: {
    ...mapState(useAppOrdersStore, [
      'dataClient',
      'filters',
    ]),
    ...mapState(useAppConfigStore, ['userEnviroment']),

    ...mapWritableState(useAppOrdersStore, [
      'actualOrder',
      'salesOrderListByday',
      'estadoPedidoCopiado',
      'estadoLineaCopiada',
      'estadoLineaEditada',
      'salesOrderLine',
      'mixedOrderLines',
      'initStateOrder',
      'dataClient',
    ]),

    toolbarKey() {
      return 'main-OrderDetail'; // dentificador único para cada toolbar
    },

  },
  async mounted() {
    await this.StartComponent();
    if (!this.initStateOrder) {
      setTimeout(() => {
        this.initStateOrder = this.deepClone(this.actualOrder);
      }, 2000);
    }
  },
  methods: {
    ...mapActions(useAppOrdersStore, ['resetValuesApp']),

    async StartComponent() {
      this.mixedOrderLines = null;
      this.deliveryDate = SoporteFechaYHora.obtenerDDMMAA(this.actualOrder.FechaEntrega);
      this.GetDefaultCurrencies();
      if (this.actualOrder.Observaciones) {
        this.observations = this.actualOrder.Observaciones.Texto;
      }

      if (!this.nuevoPedido) {
        await this.UpdateActualOrder();
      }

      this.OrderLineToAccordeon(this.actualOrder);
      this.GetReservations();
    },

    PressGuardar() {
      Log(this, this.PressGuardar.name);
      /* REALIZAR LLAMADA Y GUARDAR DATOS DEL NUEVO PEDIDO O ACTUALIZAR ALGUNO ANTERIOR */
      this.resetValuesApp();
      f7.views.main.router.navigate('/QueryOrders/', {
        force: true,
        reloadAll: true,
      });
    },
    OrderLineToAccordeon(line) {
      Log(this, this.OrderLineToAccordeon.name);
      this.elementFilter = [];
      const completos = {
        items: line.lineasPedidoVenta.filter((linea) => linea.PaleMixto === 0 && linea.TipoLinea === 0),
        Estado: this.$t('common.numberCompletedPl'),
      };
      const texto = {
        Estado: this.$t('common.text'),
        items: line.lineasPedidoVenta.filter((linea) => linea.TipoLinea === 1),
      };

      const paletsMixtos = line.lineasPedidoVenta.filter((linea) => linea.PaleMixto !== 0 && linea.TipoLinea === 0);

      const mixto = paletsMixtos.reduce((result, palet) => {
        const existingItem = result.find((item) => item.PaleMixto === palet.PaleMixto);
        if (existingItem) {
          existingItem.items.push(palet);
        } else {
          const newItem = {
            Estado: this.$t('commercialization.common.mixedPalletStatus'),
            PaleMixto: palet.PaleMixto,
            items: [palet],
          };
          result.push(newItem);
        }

        return result;
      }, []);

      if (completos.items.length > 0) {
        this.elementFilter.push(completos);
      }
      if (texto.items.length > 0) {
        this.elementFilter.push(texto);
      }

      mixto.forEach((element) => {
        this.elementFilter.push(element);
      });
    },

    GetOrderLineSelected(item) {
      Log(this, this.GetOrderLineSelected.name);
      this.orderLineSelected = item;
      this.LineItemOptions = true;
    },
    /* ***Actions Opcion Order ***** */
    LineItemSelected() {
      Log(this, this.LineItemSelected.name);
      this.LineItemOptions = true;
    },
    CloseLineItemOptions() {
      Log(this, this.CloseLineItemOptions.name);
      this.LineItemOptions = false;
    },
    async duplicateOrder() {
      Log(this, this.duplicateOrder.name);
      this.estadoPedidoCopiado = true;
      const actualOrder = { ...this.actualOrder };
      actualOrder.Id = 0;
      for (let i = 0; i < actualOrder.lineasPedidoVenta.length; i += 1) {
        const element = actualOrder.lineasPedidoVenta[i];
        element.Id = 0;
        element.IdTemporal = i;
      }
      this.actualOrder = actualOrder;
      f7.views.main.router.navigate('/FrmNewOrder/');
    },
    editOrder() {
      Log(this, this.editOrder.name);
      f7.views.main.router.navigate('/FrmNewOrder/', {
        props: {
          editarCabecera: true,
        },
      });
    },
    duplicateLine(orderLineSelected) {
      Log(this, this.duplicateLine.name);
      this.estadoLineaEditada = true;
      this.estadoLineaCopiada = true;
      this.salesOrderLine = orderLineSelected;
      if (orderLineSelected.PaleMixto !== 0 && orderLineSelected.TipoLinea === 0) {
        f7.views.main.router.navigate('/newMixtedOrderLine/', {
          props: {
            nuevoPedido: this.nuevoPedido,
          },
        });
      } else if (orderLineSelected.PaleMixto === 0 && orderLineSelected.TipoLinea === 0) {
        f7.views.main.router.navigate('/frmOrderCompleteProducto/', {
          props: {
            nuevoPedido: this.nuevoPedido,
          },
        });
      } else {
        f7.views.main.router.navigate('/frmNewTextOrderLine/', {
          props: {
            nuevoPedido: this.nuevoPedido,
          },
        });
      }
    },

    editLine(orderLineSelected) {
      Log(this, this.editLine.name);
      this.estadoLineaEditada = true;
      this.salesOrderLine = orderLineSelected;
      if (orderLineSelected.PaleMixto !== 0 && orderLineSelected.TipoLinea === 0) {
        f7.views.main.router.navigate('/newMixtedOrderLine/', {
          props: {
            nuevoPedido: this.nuevoPedido,
          },
        });
      } else if (orderLineSelected.PaleMixto === 0 && orderLineSelected.TipoLinea === 0) {
        f7.views.main.router.navigate('/frmOrderCompleteProducto/', {
          props: {
            nuevoPedido: this.nuevoPedido,
          },
        });
      } else {
        f7.views.main.router.navigate('/frmNewTextOrderLine/', {
          props: {
            nuevoPedido: this.nuevoPedido,
          },
        });
      }
    },
    async deleteLine(orderLineSelected) {
      Log(this, this.deleteLine.name);

      const alertTitle = this.$t('commercialization.deleteOrderLine.title');
      const alertText = this.$t('commercialization.deleteOrderLine.text');

      if (orderLineSelected.Id === 0) {
        const resultConfirm = await ConfirmDialogGH(alertText, alertTitle);
        if (resultConfirm) {
          const actualOrder = { ...this.actualOrder };

          for (let i = 0; i < actualOrder.lineasPedidoVenta.length; i += 1) {
            const element = actualOrder.lineasPedidoVenta[i];
            if (element.IdTemporal === orderLineSelected.IdTemporal && element.Id === orderLineSelected.Id) {
              actualOrder.lineasPedidoVenta.splice(i, 1);
            }
          }
          this.actualOrder = actualOrder;
          this.OrderLineToAccordeon(this.actualOrder);
        }
      } else {
        const resultConfirm = await ConfirmDialogGH(alertText, alertTitle);
        if (resultConfirm) {
          const resultSave = await this.DeleteSaleOrderLines([orderLineSelected]);
          if (resultSave == null) {
            HiNotification.Toast(this.$t('commercialization.info.couldNotDeleteLine'));
            return;
          }
          if (!resultSave.Valor) {
            HiNotification.Toast(resultSave.Mensaje);
          }
          await this.UpdateActualOrder();
        }
      }
    },
    async UpdateActualOrder() {
      Log(this, this.UpdateActualOrder.name);
      // Al actulizar el pedido se pierden las lineas que todavia no se habian guardado por eso vamos a guardar los registros que solo teniamos en local
      // y despues actualizamos el pedido
      const listaValoresLocales = [];
      const listaLineasExistentesEditadas = [];
      const actualOrder = { ...this.actualOrder };
      actualOrder.lineasPedidoVenta.forEach((element) => {
        if (element.Id === 0) {
          listaValoresLocales.push(element);
        }
        // Guardamo antes de actualizar la pagina las lineas que se han editado pq al actulizar se borran los cambios
        if ('LineaEditada' in element) {
          if (element.LineaEditada) {
            listaLineasExistentesEditadas.push(element);
          }
        }
      });

      await this.GetQueryOrders();
      let actualOrderActualizado = null;
      this.ordersData.forEach((element) => {
        if (element.Id === this.actualOrder.Id) {
          actualOrderActualizado = element;
        }
      });
      const orderActualizadoTotalLineas = actualOrderActualizado.lineasPedidoVenta.length;
      for (let i = 0; i < listaValoresLocales.length; i += 1) {
        const element = listaValoresLocales[i];
        element.IdTemporal = orderActualizadoTotalLineas + i;
        actualOrderActualizado.lineasPedidoVenta.push(element);
      }
      listaLineasExistentesEditadas.forEach((editada) => {
        for (let i = 0; i < actualOrderActualizado.lineasPedidoVenta.length; i += 1) {
          const element = actualOrderActualizado.lineasPedidoVenta[i];
          if (editada.Id === element.Id) {
            actualOrderActualizado.lineasPedidoVenta[i] = editada;
          }
        }
      });

      this.actualOrder = actualOrderActualizado;
      this.OrderLineToAccordeon(this.actualOrder);
    },
    async callBackBtn() {
      Log(this, this.callBackBtn.name);
      const result = this.compareObjects(this.initStateOrder, this.actualOrder);
      if ((!result && this.initStateOrder) || this.nuevoPedido) {
        this.$refs.UCConfirmation.create(
          this.$t('commercialization.info.changesNotSavedBack.title'),
          this.$t('commercialization.info.changesNotSavedBack.text'),
          () => {
            this.back();
          },
        );
        this.$refs.UCConfirmation.show();
      } else {
        this.back();
      }
    },
    async back() {
      Log(this, this.callBackBtn.name);
      if (this.nuevoPedido) {
        await sleep(100);
        this.resetValuesApp();
        f7.views.main.router.navigate('/commercialisation/salesOrder/frmSalesOrder', {
          force: true,
          reloadAll: true,
          on: {
            pageAfterIn: async () => {
              await sleep(500);
              f7.views.main.router.clearPreviousHistory();
              f7.views.main.router.back();
            },
          },
        });
      } else {
        let value = null;
        this.salesOrderListByday.forEach((element) => {
          if (element.CodigoCliente === this.dataClient.Codigo) {
            value = element;
          }
        });

        f7.views.main.router.navigate('/orderInquiry/', {
          ignoreCache: true,
          reloadPrevious: true,
          props: {
            order: value,
            filtros: this.filtros,
          },
        });
        await sleep(500);
        f7.views.main.router.back();
      }
    },
    async PressDescartarPedido() {
      Log(this, this.PressDescartarPedido.name);
      // this.resetValuesApp();
      const resultSave = await this.DeleteSaleOrder(this.actualOrder.Id);
      if (resultSave == null) {
        HiNotification.Toast(this.$t('commercialization.info.couldNotDeleteSalesOrder'));
        return;
      }
      if (!resultSave.Valor) {
        HiNotification.Toast(resultSave.Mensaje);
        return;
      }
      await this.GetQueryOrders();
      let value = null;
      this.salesOrderListByday.forEach((element) => {
        if (element.CodigoCliente === this.dataClient.Codigo) {
          value = element;
        }
      });
      if (!value) {
        // si no hay coincidencia pq el cliente se ha quedo sin pedidos volvemos a la pagina principal sino volvemos a la pagina anterior con los pedido del cliente
        f7.views.main.router.navigate('/commercialisation/salesOrder/frmSalesOrder', {
          ignoreCache: true,
          reloadPrevious: true,
        });
        await sleep(500);
        f7.views.main.router.back();
      } else {
        f7.views.main.router.navigate('/orderInquiry/', {
          ignoreCache: true,
          reloadPrevious: true,
          props: {
            order: value,
          },
        });
        await sleep(500);
        f7.views.main.router.back();
      }
    },
    PressBtnAdd() {
      Log(this, this.PressBtnAdd.name);
      this.estadoPedidoCopiado &&= false;
      this.selectCompleteOrMixt = true;
    },
    PressCompleto() {
      Log(this, this.PressCompleto.name);
      this.selectCompleteOrMixt = false;
      f7.views.main.router.navigate('/frmOrderCompleteProducto/', {
        props: {
          nuevoPedido: this.nuevoPedido,
        },
      });
    },

    PressMixto() {
      Log(this, this.PressMixto.name);
      this.selectCompleteOrMixt = false;
      f7.views.main.router.navigate('/newMixtedOrderLine/', {
        props: {
          nuevoPedido: this.nuevoPedido,
        },
      });
    },

    PressText() {
      Log(this, this.PressText.name);
      this.selectCompleteOrMixt = false;
      f7.views.main.router.navigate('/frmNewTextOrderLine/', {
        props: {
          nuevoPedido: this.nuevoPedido,
        },
      });
    },
    async saveSaleOrder() {
      Log(this, this.saveSaleOrder.name);
      // GUARDAMOS OBSERVACIONES DEL PEDIDO
      const actualOrder = { ...this.actualOrder };
      actualOrder.Observaciones = {
        Texto: this.observations,
      };
      this.actualOrder = actualOrder;
      // Guardado de pedido venta
      const resultSave = await this.SaveOrder(this.actualOrder);
      if (!resultSave) {
        return;
      }
      if (!resultSave.Valor) {
        HiNotification.Toast(resultSave.Mensaje, 3500);
        return;
      }
      f7.views.main.router.navigate('/commercialisation/salesOrder/frmSalesOrder', {
        ignoreCache: true,
        reloadPrevious: true,
      });
      await sleep(500);
      f7.views.main.router.back();
    },
    async GroupByCustomer(data) {
      Log(this, this.GroupByCustomer.name);
      const result = {};

      for (const item of data) {
        const codigoCliente = item.Cliente.Codigo;
        const nombreCliente = item.Cliente.Nombre;
        const fechaEntrega = item.FechaEntrega;
        const key = `${codigoCliente}-${fechaEntrega}`;

        if (result[key]) {
          result[key].items.push(item);
        } else {
          result[key] = {
            NombreCliente: nombreCliente,
            CodigoCliente: codigoCliente,
            FechaEntrega: fechaEntrega,
            items: [item],
          };
        }
      }

      const res = Object.values(result);

      this.salesOrderListByday = res;
    },
    assignReservationsPerLineOrder(reservas) {
      Log(this, this.assignReservationsPerLineOrder.name);

      this.actualOrder.lineasPedidoVenta.forEach((linea) => {
        linea.LineaReserva = [];
        reservas.forEach((lineaReserva) => {
          if (linea.Id === lineaReserva.Id_LineaPedidoVenta) {
            linea.LineaReserva.push(lineaReserva);
          }
        });
      });
      this.cargandoPorentajes = false;
    },
    gerPercentage(lineaPedido) {
      if (lineaPedido?.LineaReserva && Array.isArray(lineaPedido.LineaReserva)) {
        let percent = 0;
        let cantidadEnvaseRealizadoReal = 0;
        let cantidadTotal = 0;
        lineaPedido.LineaReserva.forEach((element) => {
          cantidadEnvaseRealizadoReal += element.CantidadEnvaseRealizadoReal;
          cantidadTotal += element.CantidadTotal;
        });
        if (cantidadTotal !== 0) {
          percent = (cantidadEnvaseRealizadoReal * 100) / cantidadTotal;
          return Math.round(percent);
        }
        return 0;
      }
      return 0;
    },
    deepClone(obj) {
      Log(this, this.deepClone.name);
      return JSON.parse(JSON.stringify(obj));
    },
    compareObjects(initStateOrder, actualOrder) {
      Log(this, this.compareObjects.name);
      const cadena1 = JSON.stringify(initStateOrder);
      const cadena2 = JSON.stringify(actualOrder);

      if (cadena1 === cadena2) {
        return true;
      }
      return false;
    },
    GetPriority() {
      Log(this, this.GetPriority.name);
    },
    GetPriorityByCode() {
      Log(this, this.GetPriorityByCode.name);
    },
    GetWorkShift() {
      Log(this, this.GetWorkShift.name);
    },
    GetWorkShifByCode() {
      Log(this, this.GetWorkShifByCode.name);
    },

    EventWorkShiftSelected() {
      Log(this, this.EventWorkShiftSelected.name);
    },
    EventPrioritySelected() {
      Log(this, this.EventPrioritySelected.name);
    },

    async SaveOrder(objOrder) {
      HiDialog.Preloader(true, this.$t('commercialization.info.savingSalesOrder'), false);
      try {
        const result = await APIErp.callSaveSaleOrder(objOrder);
        HiDialog.Preloader(false);
        return result.data;
      } catch (error) {
        HiDialog.Preloader(false);
        HiNotification.Alert(error.response.data.Mensaje, this.$t('commercialization.info.salesOrderNotCreated'));
        return null;
      }
    },
    async DeleteSaleOrder(id) {
      HiDialog.Preloader(true, this.$t('commercialization.info.deletingSalesOrder'), false);
      try {
        const result = await APIErp.callDeleteSaleOrder(id);
        HiDialog.Preloader(false);
        return result.data;
      } catch (error) {
        HiDialog.Preloader(false);
        HiNotification.Alert(error.response.data.Mensaje, this.$t('commercialization.info.couldNotDeleteSalesOrder'));
        return null;
      }
    },
    async DeleteSaleOrderLines(listLines) {
      HiDialog.Preloader(true, this.$t('commercialization.info.deletingSalesOrderLine'), false);
      try {
        const result = await APIErp.callDeleteSaleOrderLine(listLines);
        HiDialog.Preloader(false);
        return result.data;
      } catch (error) {
        HiDialog.Preloader(false);
        HiNotification.Alert(error.response.data.Mensaje, this.$t('commercialization.info.couldNotDeleteLine'));
        return null;
      }
    },
    async GetQueryOrders() {
      Log(this, this.GetQueryOrders.name);
      HiDialog.Preloader(true, this.$t('common.updatingInformation'), false);

      this.salesOrderListByday = null;

      const idSujetoVendedor = this.filtrarPedidosVentaVendedorAPP
        ? this.userEnviroment.EntornoDeTrabajo.Usuario.Sujeto?.Id
        : 0;

      try {
        const result = await callExecuteSPERP(
          'APPERPAGRO_ObtenerPedidoVentaFecha',
          [
            { NombreParametro: 'fechaInicio', Valor: this.filters.fechaInicio },
            { NombreParametro: 'fechaFin', Valor: this.filters.fechaFin },
            { NombreParametro: 'fechaInicioEntrega', Valor: this.filters.fechaInicioEntrega },
            { NombreParametro: 'fechaFinEntrega', Valor: this.filters.fechaFinEntrega },
            { NombreParametro: 'id_Pedido', Valor: this.filters.id_Pedido },
            { NombreParametro: 'id_Cliente', Valor: this.filters.id_Cliente },
            { NombreParametro: 'referencia', Valor: this.filters.referencia },
            { NombreParametro: 'idCentro', Valor: this.userEnviroment.EntornoDeTrabajo.Centro?.Id },
            { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa?.Id },
            { NombreParametro: 'idSujetoVendedor', Valor: idSujetoVendedor },
          ],
          'Ventas.PedidoVentaJSON',
        );
        this.ordersData = result.data;
        this.GroupByCustomer(result.data);
      } catch (error) {
        LogError(this, this.GetQueryOrders.name, error);
      }

      HiDialog.Preloader(false);
    },
    GetDefaultCurrencies() {
      Log(this, this.GetDefaultCurrencies.name);
      callExecuteSPERP(
        'APPERPAGRO_Divisas',
        [],
        'Comun.DivisaJSON',
      ).then((result) => {
        if (result.status !== 200) {
          return;
        }
        const divisas = result.data;
        divisas.forEach((element) => {
          if (this.actualOrder.Cliente.Id_Divisa !== 0) {
            if (element.Id === this.actualOrder.Cliente.Id_Divisa) {
              this.divisaSelected = element;
            }
          } else if (this.userEnviroment.EntornoDeTrabajo.IdDivisaFuncional !== 0) {
            if (element.Id === this.userEnviroment.EntornoDeTrabajo.IdDivisaFuncional) {
              this.divisaSelected = element;
            }
          }
        });
        if (!this.divisaSelected) {
          this.divisaSelected = { Simbolo: '€' };
        }
      });
    },
    async GetReservations() {
      Log(this, this.GetReservations.name);
      try {
        const result = await APIErp.callReservations(this.actualOrder.Id);
        if (!result.data.Valor) {
          return;
        }
        this.assignReservationsPerLineOrder(result.data.Tag);
      } catch (error) {
        LogError(this, this.GetReservations.name, error);
      }
    },
  },
};
</script>

<style lang="scss">
.main-OrderDetail {
  .page-content {
    overflow-y: hidden;
  }
  .container-navbar{
    .navbar-inner {
      .title {
          font-size: 16px;
          font-weight: 400;
      }
      .right{
        .link{
          padding: 0px 6px;
        }
      }
    }
  }
  .container-header{
    background: var(--f7-bars-bg-color);
    padding: 10px 14px 10px 14px;
    height: 70px;
    margin-top: -1px;
  }

  .container-toolbar{
    background: var(--f7-bars-bg-color);
    .content-toolbar {
      --f7-tabbar-link-active-color: var(--his-whispering-lilac);
      --f7-tabbar-link-active-bg-color: var(--his-mora-white);
      --f7-tabbar-link-inactive-color: #fff;
      --toolbar-bg-color: var(--his-tierra-grey);

      width: 100%;
      padding-left: 10px;
      padding-right: 10px;
      margin-top: -1px;
      padding-top: 5px;
      padding-bottom: 5px;
      .content-toolbar-elements {
        position: inherit;
        height: 50px;
        border-radius: 6px;
        margin-bottom: 12px;
        .toolbar-inner {
          padding: 7px;
          .tab-link{
            border-radius: 6px!important;
            .content-title{
              color: var(--his-darkness);
            }
          }
        }
      }
      .tabs{
        background: var(--f7-page-bg-color);
        margin: 0px -10px 0px -10px;
        height: calc(100vh - 200px);
        .tab{
          height: 100%;
        }
      }

      &__acordeon{
        height: calc(100% - 15px);
        overflow-y: scroll;
        .storybook-action-sorted-accordion{
          .accordion-list{
            --f7-list-border-color: none;
            margin: 0px;
            ul::before{
              margin: revert;
              background-color: var(--his-tierra-shade);
            }
            .accordion-item{
              .item-inner{
                padding-top: 0px;
                padding-bottom: 0px;
              }
              .accordion-item-content{
                padding-bottom: 0px;
              }
            }
          }
        }
        &--item{
          --f7-list-item-title-font-size: 16px;
          --f7-list-item-title-font-weight: 600;
          --f7-list-item-title-text-color: var(--his-berenjena);
          --f7-list-item-title-line-height: 1.2;
          padding-top: 1.2rem;
          padding-bottom: 1.2em;
          border-bottom: 1px solid var(--his-metal-light) ;
          &__subtitle-Percent{
            min-width: 60px;
            max-width: 80px;
            text-align: center;
            font-weight: 600;
            &--percent{
              border-radius: 4px;
              padding: 2px 5px 2px 5px;
            }
            &--pending{

              background-color: var(--his-oliva-tint)
            }
            &--in-progress{
              background-color: var(--his-mandarina-light)
            }
            &--finished{
              background-color: var(--his-melon-light)
            }
          }
        }
      }
      &__other{
        margin: 0px 15px 0px 15px;
        height: calc(100% - 15px);
        overflow-y: scroll;
        .text-editor{
          min-height: 200px;
          margin: 0px;
          border-radius: var(--search-input-border-radius);
          border: var(--search-input-border);
        }
        .container-complementary-data{
          --f7-list-item-title-text-color: var(--his-tierra);
          color: var(--search-title-color);
          margin: 16px;
          margin-left: 0px;
          margin-right: 0px;
          .accordion-item{
            border-radius: var(--search-input-border-radius);
            border: var(--search-input-border);
            .item-link{
              .item-content{
                margin-left: 0px;
                padding-left: 0px;
                .item-inner{
                  background-color: #fff;
                  border-radius: var(--search-input-border-radius);
                  .item-title{
                    margin-left: var(--search-title-margin-left);
                    color: var(--search-title-color);
                    font-size: var(--search-title-font-size);
                    font-weight: var(--search-title-weight);
                  }
                }
              }
            }

            .accordion-item-content{
              .content-data-list{
                .list{
                  span{
                    margin: var(--search-title-margin);
                    color: var(--search-title-color);
                    font-size: 14px;
                    font-weight: var(--search-title-weight);
                  }
                  .input-normal{
                    margin-top: 0px;
                    .item-content{
                      padding-left: 0px;
                      .item-inner{
                        padding-right: 0px;
                        input{
                          border-radius: var(--search-input-border-radius);
                          border: var(--search-input-border);
                          height: 46px;
                          color: var(--his-tierra);
                          font-size: var(--search-input-font-size);
                          padding: var(--search-input-padding);
                        }
                      }
                    }
                  }
                  .content-searcher-erp{
                    margin-right: 0px;
                    margin-left: 0px;
                    input{
                      border-radius: var(--search-input-border-radius);
                    }
                  }
                  .container-data{
                    height: 75px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

}

.order-detail-action-delete-order{
  background-color: var(--f7-page-bg-color);
  padding: 10px 25px 10px 25px;
  &__btn-delete{
    color: var(--his-mora-white);
    background: var(--his-tomate);
    border-radius: 6px;
  }
  &__btn-cancel{
    color: var(--his-tierra);
    border-radius: 6px;
  }
  .actions-label{
    background-color: var(--f7-page-bg-color);
  }
  .actions-button{
    .actions-button-text{
      text-align: center;
      font-weight: 500;
      font-size: 18px;
    }
  }
}

.order-detail-action-item-options{
  background-color: var(--f7-page-bg-color);
  --f7-actions-bg-color:var(--f7-page-bg-color);
  padding: 10px 25px 10px 25px;

  &__title{
    margin-left: -25px;
    margin-right: -25px;
    padding: 6px 20px 6px 20px;
    border-bottom: 1px solid var(--his-tierra-light);
  }
  &__btn-duplicate{
    color: var(--his-metal);
    border: 1px solid var(--his-metal);
    border-radius: 6px!important;
    background: var(--his-mora-white);
  }
  &__btn-edit{
    color: var(--his-mora-white);
    border-radius: 6px!important;
    background: var(--his-tierra);
  }
  &__btn-delete{
    color: var(--his-mora-white);
    border-radius: 6px!important;
    background: var(--his-tomate);
  }
  .actions-label{
    background-color: var(--f7-page-bg-color);
  }
  .actions-button{
    .actions-button-text{
      text-align: center;
      font-weight: 500;
      font-size: 18px;
    }
  }

}
.order-detail-action-options-line {
  padding: 10px 25px 10px 25px;
  --f7-actions-bg-color:var(--f7-page-bg-color);
  .actions-button{
    .actions-button-media{
      min-width: 85px;
      min-height: 85px;
      img{
        width: 85px;
        height: 85px;
      }
    }
  }
  .actions-label{
    background-color: var(--f7-page-bg-color);
  }
}
.order-detail-action-options-order{
  margin: 8px;
  --f7-actions-bg-color:var(--f7-page-bg-color);
  .actions-label{
    background: var(--f7-bars-bg-color);
    color: var(--his-mora-white);
    height: 35px;
  }
  .actions-button{
    .actions-button-media{
      min-width: 52px;
    }
  }
}
.container-confirmation-frm-order-detail{
  .content-action-sheet{
    &__buttons{
      height: 50px;
      &--cancel {
        background: var(--his-oliva-tint);
        color: var(--his-ajo-dark);
      }
      &--confirm {
        background-color: var(--his-arandano);
      }
    }
    &__title, &__subtitle{
      color: var(--his-tierra-shade)
    }
  }
}
</style>
